module.exports = {
    // basic
    'deleted-by': 'eliminado por',
    'deleted-on': 'eliminado el',
    'a-user': 'un usuario',
    'restore': 'restaurar',
    'restore-all': 'restaura todo',

    // raw
    'recycle-bin-restore-file-help': `<strong>Restaurar cualquier archivo también restaurará la entrada.</strong>`,
    'recycle-bin-well-deleted-help': `
        Ni estos archivos ni la entrada se pueden restaurar, porque el pozo al que pertenecen ya no existe. </br>
        Todavía se pueden descargar.
    `,

    // template
    'recycle-bin-title': (words) => `Archivos eliminados de "${words[0]}" en "${words[1]}"`,

};
